<template>
  <div class="row">
    <div class="col-lg-12 col-xl-12 mb-5">
      <div class="card card-custom">
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">Araştırma ve Reklam Firmaları</span>
            <span class="text-muted mt-1 font-weight-bold font-size-sm">{{$t('menu.user_groups')}}</span>
          </h3>
          <div class="card-toolbar">
            <b-form-group label="" class="fa-pull-right">
              <b-button-group size="sm">
                <b-button v-b-modal.edit @click="ClearForm"><i class="fas fa-plus"></i> {{$t('tests.add')}}</b-button>
                <b-button v-b-modal.multiple_upload><i class="far fa-clone"></i> {{$t('tests.add_multiple')}}</b-button>
              </b-button-group>
            </b-form-group>

            <b-modal size="lg" id="edit" :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" :title="$t('general.add')">
              <div class="row">
                <div class="col-xl-12">
                  <b-form-group id="input-group-2" label="Üye Numaraları" label-for="input-2">
                    <b-form-textarea
                        id="textarea"
                        v-model="text"
                        placeholder="Alt alta ekleyiniz..."
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                </div>
              </div>
            </b-modal>
            <b-modal id="multiple_upload" :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" :title="$t('tests.add_multiple')">
              <b-form-group id="input-group-2" :label="$t('general.file_upload')" label-for="input-2">
                <b-form-file browse-text="Dosya Seç" :placeholder="$t('general.file_upload_placeholder')" id="file-default"></b-form-file>
              </b-form-group>
            </b-modal>
          </div>
        </div>
        <div class="card-body pt-10">
          <div class="row">
            <div class="col-xl-12">
              <data-table
                  :items="items"
                  :fields="report.fields"
                  :paginate="report.paginate"
                  page.sync="3"
                  perPage.sync="10"
              >
              </data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";

export default {
  name: "InternalTestsList",
  components: { DataTable, DashboardBox },
  methods: {
    ClearForm(){
      this.form = {
        firstname: '',
        lastname : '',
        email : '',
        phone : ''
      };
    },

  },
  data() {
    return {
      form : {
        firstname : 'Çağdaş',
        lastname : 'Mert',
        email : 'cagdas.mert@dorinsight.com',
        phone : '5309617970'
      },
      items : [
        {'member_id' : '107483', 'firstname' : 'Turgut', 'lastname' : 'Açıkalın', 'email' : 'turgut.a@gmail.com', 'phone' : '5309617970', 'status' : 'Aktif' },
        {'member_id' : '107484', 'firstname' : 'Ali', 'lastname' : 'Duran', 'email' : 'ali.d@gmail.com', 'phone' : '5309617970', 'status' : 'Aktif' },
        {'member_id' : '107485', 'firstname' : 'Derya', 'lastname' : 'Can', 'email' : 'derya.c@gmail.com', 'phone' : '5309617970', 'status' : 'Aktif' },
        {'member_id' : '107486', 'firstname' : 'Kamil', 'lastname' : 'Tok', 'email' : 'kamil.t@gmail.com', 'phone' : '5309617970', 'status' : 'Aktif' },
        {'member_id' : '107487', 'firstname' : 'Tuğçe', 'lastname' : 'Zaloğlu', 'email' : 'tugce.z@gmail.com', 'phone' : '5309617970', 'status' : 'Aktif' },
      ],
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'member_id', label: 'Member ID', sortable: false},
          {key: 'firstname', label: 'Ad', sortable: false},
          {key: 'lastname', label: 'Soyad', sortable: true},
          {key: 'email', label: 'Email', sortable: true},
          {key: 'phone', label: 'Telefon', sortable: true},
          {key: 'status', label: 'Durum', sortable: true},
          {key: 'user_group_list_actions', label: 'İşlem', sortable: false},

        ],

      },
      selected : null,
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('menu.user_groups'), route: "alert" },
      { title: 'Araştırma ve Reklam Firmaları' }
    ]);
  },

}
</script>

<style scoped>

</style>
